export default "__VITE_ASSET__C5_0Sw7q__"